import { ReactNode, useRef, useState } from 'react';
import { BsQuestionCircle } from 'react-icons/bs';
import styled from 'styled-components';

import { IoIosArrowBack as LeftArrow } from 'react-icons/io';
import { IoIosArrowDown as DownArrow } from 'react-icons/io';
import { IoIosArrowUp as UpArrow } from 'react-icons/io';
import { IoIosArrowForward as RightArrow } from 'react-icons/io';

//icon
import { FcIdea } from 'react-icons/fc';

import Overlay from 'react-bootstrap/Overlay';
import React from 'react';

type VariationPlacement =
  | 'top-start'
  | 'top-end'
  | 'bottom-start'
  | 'bottom-end'
  | 'right-start'
  | 'right-end'
  | 'left-start'
  | 'left-end';
type TriggerType = 'click' | 'hover';

export interface TooltipProps {
  iconSize?: number;
  iconColor?: string;
  triggerType?: TriggerType;
  placement: VariationPlacement;
  children: ReactNode;
  mode?: 'icon' | 'text';
  customText?: string;
  onClick?: () => void;
}

const Tooltip = ({
  iconSize = 20,
  iconColor = 'var(--green)',
  triggerType = 'hover',
  placement,
  children,
  mode = 'icon',
  customText = '도움말',
  onClick,
}: TooltipProps) => {
  const [tooltipVisible, setTooltipVisible] = useState<boolean>(false);
  const target = useRef(null);
  //   const viewBox = `0 0 ${iconSize} ${iconSize}`;
  return (
    <>
      <div
        ref={target}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'help',
        }}
        onClick={onClick && onClick}
      >
        {mode === 'icon' ? (
          <BsQuestionCircle
            size={iconSize}
            //   viewBox={viewBox}
            color={iconColor}
            onClick={() =>
              triggerType === 'click'
                ? setTooltipVisible(!tooltipVisible)
                : undefined
            }
            onMouseOver={() =>
              triggerType === 'hover' ? setTooltipVisible(true) : undefined
            }
            onMouseLeave={() =>
              triggerType === 'hover' ? setTooltipVisible(false) : undefined
            }
          />
        ) : (
          <CustomText
            onClick={() =>
              triggerType === 'click'
                ? setTooltipVisible(!tooltipVisible)
                : undefined
            }
            onMouseOver={() =>
              triggerType === 'hover' ? setTooltipVisible(true) : undefined
            }
            onMouseLeave={() =>
              triggerType === 'hover' ? setTooltipVisible(false) : undefined
            }
          >
            {customText}
          </CustomText>
        )}
      </div>
      <Overlay
        target={target.current}
        show={tooltipVisible}
        placement={placement}
      >
        <Container className='even-shadow'>
          <MainContainer>
            <FcIdea
              size={25}
              style={{ marginLeft: '6px', marginRight: '6px' }}
            />
            <ItemContainer>
              {React.Children.map(children, (child, index) => (
                <Item key={index}>{child}</Item>
              ))}
            </ItemContainer>
          </MainContainer>
        </Container>
      </Overlay>
    </>
  );
};

export default Tooltip;

const Container = styled.div`
  * {
    box-sizing: border-box;
  }
  flex: 1;
  z-index: 9999;
  position: absolute;
  border-radius: 8px;
  background-color: white;
  padding: 3px;
`;

const MainContainer = styled.div`
  border: 1px dashed var(--green);
  padding: 8px 5px 8px 0px;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

const ItemContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
`;

const Item = styled.div`
  font-weight: 600;
  letter-spacing: 0.5px;
  font-size: 16px;
  line-height: 20px;
`;

const CustomText = styled.div`
  margin-top: 0;
  margin-bottom: 0;
  text-align: center;
  align-content: center;
  text-decoration: underline;
  margin-right: 10px;
`;
